var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Cuuho = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1136)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 38H-0.75V51H50.25V38Z",
    fill: "url(#paint0_linear_47_1136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 37.875H9.25C8.635 37.875 8.125 38.385 8.125 39C8.125 39.615 8.635 40.125 9.25 40.125H39.25C39.865 40.125 40.375 39.615 40.375 39C40.375 38.385 39.865 37.875 39.25 37.875Z",
    fill: "url(#paint1_linear_47_1136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75 9H16.75C12.25 9 10.75 11.685 10.75 15V39H19.75V29.91C19.75 29.13 20.38 28.5 21.16 28.5H27.355C28.12 28.5 28.765 29.13 28.765 29.91V39H37.765V15C37.75 11.685 36.25 9 31.75 9ZM28 19.875H25.375V22.5C25.375 23.115 24.865 23.625 24.25 23.625C23.635 23.625 23.125 23.115 23.125 22.5V19.875H20.5C19.885 19.875 19.375 19.365 19.375 18.75C19.375 18.135 19.885 17.625 20.5 17.625H23.125V15C23.125 14.385 23.635 13.875 24.25 13.875C24.865 13.875 25.375 14.385 25.375 15V17.625H28C28.615 17.625 29.125 18.135 29.125 18.75C29.125 19.365 28.615 19.875 28 19.875Z",
    fill: "url(#paint2_linear_47_1136)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_1136",
    x1: 24.75,
    y1: 38,
    x2: 24.75,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_1136",
    x1: 8.125,
    y1: 38.8312,
    x2: 40.375,
    y2: 38.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_1136",
    x1: 10.75,
    y1: 21.75,
    x2: 37.765,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Cuuho, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2cuuho.e48ebcb5.svg";
export { ForwardRef as ReactComponent };